import { useFlags as useFlagsClient } from 'launchdarkly-react-client-sdk'

import { useFlagContext } from './FlagContext'
import { LaunchDarklyFlags } from './featureFlags'

/**
 * Hook to access LaunchDarkly feature flags
 * Returns flags in camelCase format (e.g., 'oo-new-feature' becomes 'ooNewFeature')
 *
 * @example
 * const { ooEthycaAds, dotFundraisingSurcharging } = useFlags()
 *
 * Note: All flag keys must be defined in the LaunchDarklyFeatureFlag enum
 * to ensure they're loaded and available
 */
export const useFlags = (): LaunchDarklyFlags => {
  const clientFlags = useFlagsClient()
  const serverFlags = useFlagContext()
  // Use Client Hook will render a frame of undefined
  // That hook is used broadly in the codebase so doing a specialized
  // check here to avoid broad application changes
  const isClient = typeof window !== 'undefined'

  if (isClient) {
    return clientFlags as LaunchDarklyFlags
  }

  return serverFlags as LaunchDarklyFlags
}
